import featured from './featured.vue';
import featuredused from './featured-used.vue';
import news from './news.vue';
import loginmodal from '../shared/login-modal.vue';
import favoriteButton from '../shared/favorite-button.vue';
import SearchUsedVehiclesService from '../scripts/services/pesquisa.js';
import SearchNewVehiclesService from '../scripts/services/pesquisa-new-vehicle.js';
import helper from '../scripts/helper.js'


new Vue({

    el: "#home",
    components: {
        featured,
        featuredused,
        news,
        favoriteButton,
        loginmodal
    },
    data() {
        return {
            UsedVehiclesBrands: {},
            showAll: false
        }
    },
    methods: {
        async loadData() {
            let usedBrands = await SearchUsedVehiclesService.GetBrands();

            this.UsedVehiclesBrands = usedBrands;
        },
        getBrandLink(id, isUsed, name) {
            if (isUsed) {
                var params = new URLSearchParams({"marca": helper.RemoveAccents(name.toLowerCase())});
                return decodeURI("/carros-usados?" + params.toString());
            } else {
                return "/carro/novo/assistente-de-pesquisa?b=" + id;
            }
        }
    },
    mounted() {
        this.loadData();
    }

})
